export default {
  GET_BANNER(state, payload) {
    state.banner = payload;
  },

  GET_ABOUT_US(state, payload) {
    state.aboutUs = payload;
  },

  SELECTED_BANNER(state, payload) {
    state.selectedBanner = payload;
  },

  SELECTED_CONTENT(state, payload) {
    state.selectedContent = payload;
  },
};
